import { useSyncExternalStore } from 'react';
import { authStore, AuthState } from '../store/authStore';

// Lit l'état d'authentification (store observable) et re-render le composant
// quand il change. Brique de base partagée par useAuth et tout composant qui
// n'a besoin que de lire l'état (ex: GlobalResultsPage).
export function useAuthState(): AuthState {
  return useSyncExternalStore(authStore.subscribe, authStore.getState, authStore.getState);
}
